import {PatchServiceOrderVariantDepositApiArg} from '@dms/api/workshop';
import {buildDepositPatchBody as buildCanonicalDepositPatchBody} from '@dms/settings/shared';

import {FormType} from '../types/ServiceOrderVariant';

type DepositPatchBody = PatchServiceOrderVariantDepositApiArg['body'];

// The service order API spells the deposit document series `documentSerieId`, while the shared
// form and its patch body use the canonical `documentSeriesId`. The name is translated here, at
// the API boundary, so the difference never reaches the form.
export function buildDepositPatchBody(deposit: FormType['deposit']): DepositPatchBody {
  const {documentSeriesId, ...body} = buildCanonicalDepositPatchBody(deposit);

  return {...body, documentSerieId: documentSeriesId};
}
